// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gw-block.gw-nav-block{--block-background:var(--color-white-10)}.gw-block.gw-nav-block,.gw-block.gw-nav-block .gw-block__body{--block-color:var(--color-gray-400)}.gw-block.gw-nav-block .gw-block__title{--block-color:var(--color-lightest)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
